/**
 * gpas-report-services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OBillingDto } from './oBillingDto';
import { OPropertyDto } from './oPropertyDto';


export interface OBillingResponseDto { 
    propertys?: Array<OPropertyDto> | null;
    data?: Array<OBillingDto> | null;
    totals?: OBillingDto;
}

